import axios from 'axios'

let baseUrl = "";
if (process.env.NODE_ENV === "development") {
    baseUrl = process.env.VUE_APP_BASE_URL;
} else {
    baseUrl = process.env.VUE_APP_BASE_URL;
}

const request = axios.create();

const token = localStorage.getItem("userToken");
const deviceId = localStorage.getItem("deviceId");
// const instances = [{"ipAddr": "localhost", "port": 8090}]
// const instances = [{"ipAddr": "172.21.0.4", "port": 8090}]
// const instances = [{"ipAddr": "127.0.0.1", "port": 8090}, {"ipAddr": "exam-backend2", "port": 8091}]

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {

    config.baseURL = baseUrl;
    config.timeout = 5000;
    // config.headers["Content-Type"] = 'application/json;charset=utf-8';
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers.set("deviceId", deviceId);
    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        // let res = response.data;
        // // 如果是返回的文件
        // if (response.config.responseType === 'blob') {
        //     return res
        // }
        // // 兼容服务端返回的字符串数据
        // if (typeof res === 'string') {
        //     res = res ? JSON.parse(res) : res
        // }
        return response;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)

export default request

